var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chart-content"},[(_vm.ready)?_c('line-chart',{staticClass:"line-chart",attrs:{"chartData":this.chartData,"options":this.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }